import { GiocaBriscola } from './GiocaBriscola';
import { IconaTutorialBriscola } from './IconaTutorialBriscola';
import { TavoliMieiBriscola } from './TavoliMieiBriscola';

/**
 * La Hub della briscola (sul modello della Hub della scopa, `components/scopa/HubScopa.tsx`): col gioco attivo = Briscola la Hub non ha la riga delle sezioni, ha DUE blocchi —
 * «Gioca» (uno contro uno o due contro due; Gioca, contro i robot nei tre livelli, Invita un amico, Entra con un codice) e «I miei tavoli / Riprendi» (la lobby comune di
 * `components/gamehost/TavoliMiei.tsx`, PR comune A3, col gioco come parametro: `TavoliMieiBriscola`) — dentro UN solo scorrevole. I tornei e la classifica sono P9, fuori da qui. La
 * stessa Hub e la pagina `/briscola` (`routes/briscola/BriscolaHome.tsx`).
 *
 * ⚠️ Il padding in basso e' `max(0.5rem, var(--ingombro-flottante, 0px))` (la variabile la scrive il bottone dei minigiochi quando e' montato, v. `lib/minigiochiPosizione.ts`; stringa copiata, non importata): l'ultimo
 * elemento («Riprendi» in «I miei tavoli») scorre sopra il bottone invece di restargli sotto; senza il bottone la variabile non c'e' e il padding e' 0,5rem, come prima.
 *
 * ⚠️ Lo montano `HubSections` e la rotta SOLO dentro il confronto LETTERALE del flag `VITE_FEATURE_BRISCOLA_ENABLED` (che il bundler piega): questo file e il marcatore
 * `data-hub-briscola` non sono in produzione. La serratura (`beta`, Limulo acceso) sta in `HubSections`, nel selettore e nel `RoleGate` della rotta.
 */
export function HubBriscola() {
  return (
    <div data-hub-briscola className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain pb-[max(0.5rem,var(--ingombro-flottante,0px))] pt-2 [touch-action:pan-y]">
      <div className="flex shrink-0 justify-end px-2">
        <IconaTutorialBriscola />
      </div>
      <GiocaBriscola />
      <TavoliMieiBriscola />
    </div>
  );
}
